import PrivacyComp from "components/PrivacyComp/v20260601";
import { useRouter } from "src/hooks/useRouter";


const PrivacyCompPage: React.FC = () => {
  const { goLogin } = useRouter();
  return (
    <>
      <div>
        <div className="top">
          {/* <a onClick={goLogin}>
            <div className="icon_fasoo main" />
          </a> */}
        </div>
      </div>
      <div style={{ width: "90%", margin: "auto" }}>
        <PrivacyComp></PrivacyComp>
      </div>
    </>
  );
};

export default PrivacyCompPage;
